import { FC, ReactNode } from 'react';
import styles from './Head.css';
import { clsx } from 'clsx';
import { ArticleHeading1, ArticleParagraph1 } from '@cian/ui-kit';

interface IHeadProps {
  title: string;
  newbuildingInfo: ReactNode;
  location: string;
  transportDistance: ReactNode;
  factoids: ReactNode;
  panorama: ReactNode;
}

export const Head: FC<IHeadProps> = ({ title, newbuildingInfo, location, transportDistance, factoids, panorama }) => {
  return (
    <div className={styles['head']}>
      <div className={styles['info']}>
        <div className={styles['main']}>
          <div className={styles['title']}>
            <ArticleHeading1 as="h1">{title}</ArticleHeading1>
          </div>
          <div className={clsx(styles['newbuilding-info'], styles['hide-if-empty'])}>{newbuildingInfo}</div>
          <div className={styles['location']}>
            <ArticleParagraph1 color="gray60_100">{location}</ArticleParagraph1>
          </div>
          <div className={clsx(styles['transport-accessibility'], styles['hide-if-empty'])}>{transportDistance}</div>
        </div>
        <div className={clsx(styles['panorama-button'], styles['hide-if-empty'])}>{panorama}</div>
      </div>
      <div className={clsx(styles['factoids'], styles['hide-if-empty'])}>{factoids}</div>
    </div>
  );
};
